export const ERROR_MESSAGES_MAP: Record<string, string> = {
    // Authentication errors
    ["email must be an email"]: "E-mail inválido. Por favor, verifique.",
    ["User not found"]: "Usuário não encontrado. Verifique os dados informados.",
    ["password must be longer than or equal to 8 characters"]: "A senha deve ter pelo menos 8 caracteres",
    ["There is already a user with some unique fields"]: "Este e-mail ou nome de usuário já está em uso",
    ["Invalid credentials"]: "Credenciais inválidas. Verifique seu e-mail e senha.",
    ["Password is incorrect"]: "Senha incorreta. Tente novamente.",
    ["User is not verified"]: "Sua conta não foi verificada. Verifique seu e-mail.",
    ["Token expired"]: "Sua sessão expirou. Por favor, faça login novamente.",
    ["Invalid token"]: "Token inválido. Por favor, faça login novamente.",
    ["birth should not be empty"]: "A data de nascimento não pode estar vazia",
    ["birth must be a Date instance"]: "A data de nascimento deve ser uma data válida",

    // Team errors
    ["There is already a team with some unique fields"]: "Já existe um time com este nome ou tag",
    ["User is not the owner of the team"]: "Você não é o proprietário do time",
    ["Team not found"]: "Time não encontrado",
    ["User is already in a team"]: "Você já está em um time",
    ["User is not in the team"]: "Você não faz parte deste time",
    ["Invitation not found"]: "Convite não encontrado ou expirado",
    ["User already invited"]: "Este usuário já foi convidado para o time",
    ['There is already a team with some name field']: "Já existe um time com este nome",
    ['There is already a team with some team tag field']: "Já existe um time com esta tag",
    // Permission errors
    ["Forbidden resource"]: "Você não tem permissão para acessar este recurso",
    ["Permission denied"]: "Permissão negada para realizar esta ação",

    // Resource errors
    ["Resource not found"]: "Recurso não encontrado",
    ["Resource already exists"]: "Este recurso já existe",

    // Input validation errors
    ["username must be longer than or equal to 3 characters"]: "O nome de usuário deve ter pelo menos 3 caracteres",
    ["username must be shorter than or equal to 20 characters"]: "O nome de usuário deve ter no máximo 20 caracteres",
    ["username must match /^[a-zA-Z0-9_-]+$/ regular expression"]: "O nome de usuário deve conter apenas letras, números, _ e -",
    ["name must be longer than or equal to 3 characters"]: "O nome deve ter pelo menos 3 caracteres",
    ["name must be shorter than or equal to 50 characters"]: "O nome deve ter no máximo 50 caracteres",

    ["Service unavailable"]: "Serviço temporariamente indisponível. Tente novamente mais tarde.",

    // WebSocket errors
    ["WebSocket connection failed"]: "Falha na conexão com o serviço de notificações em tempo real",
    ["Failed to connect to notification service"]: "Não foi possível conectar ao serviço de notificações",

    // Generic errors
    ["Bad request"]: "Requisição inválida. Verifique os dados informados.",
    ["Request timeout"]: "A requisição demorou muito para responder. Verifique sua conexão.",
    ["There is already a payment for this item, if you have any problems please ask support for help."]: "Já existe um pagamento para este item. Se você tiver algum problema, peça ajuda ao suporte.",
    ["Invalid CPF, please add a valid CPF in configuration user"]: "CPF inválido. Por favor, adicione um CPF válido na configuração do usuário",


};
